import { trimFromLeft, trimFromRight } from './String';

export const classNameFromEnumValue = (enumValue: string, prefix?: string, suffix?: string): string => {
    const prefixString = prefix ? `${trimFromRight(prefix, '-')}--` : '';
    const suffixString = suffix ? `-${trimFromLeft(suffix, '-')}` : '';
    return prefixString + enumValue.toLowerCase().replace(/_/g, '-') + suffixString;
};
